import z from 'zod'
import { Farm } from '../../domain/entities/Farm'

export const FarmSchema = z
	.object({
		ativo: z.boolean().nullish(),
		fzda_cd_codigo: z.number().nullish(),
		fzda_cd_matricula: z.string().nullish(),
		fzda_ds_descricao: z.string().nullish(),
		fzda_jsonb_custom_variable: z.array(z.record(z.string(), z.string())).nullish(),
		fzda_md_area: z.number().nullish(),
		fzda_nm_arrendatario: z.string().nullish(),
		fzda_nm_bairro: z.string().nullish(),
		fzda_nm_cep: z.string().nullish(),
		fzda_nm_endereco: z.string().nullish(),
		fzda_nm_estado: z.string().nullish(),
		fzda_nm_municipio: z.string(),
		fzda_nm_nome: z.string(),
		fzda_nm_pais: z.string(),
		fzda_nm_proprietario: z.string().nullish(),
		fzda_nm_referencia: z.string().nullish(),
		id: z.string().nullish(),
		possuiDependenciaDeRegistro: z.boolean().nullish(),
	})
	.transform(
		(data) =>
			new Farm(
				data.fzda_nm_nome,
				data.fzda_nm_municipio,
				data.fzda_nm_pais,
				data.ativo ?? undefined,
				data.fzda_cd_codigo ?? undefined,
				data.fzda_cd_matricula ?? undefined,
				data.fzda_ds_descricao ?? undefined,
				data.fzda_jsonb_custom_variable ?? undefined,
				data.fzda_md_area ?? undefined,
				data.fzda_nm_arrendatario ?? undefined,
				data.fzda_nm_bairro ?? undefined,
				data.fzda_nm_cep ?? undefined,
				data.fzda_nm_endereco ?? undefined,
				data.fzda_nm_estado ?? undefined,
				data.fzda_nm_proprietario ?? undefined,
				data.fzda_nm_referencia ?? undefined,
				data.id ?? undefined,
				data.possuiDependenciaDeRegistro ?? undefined,
			),
	)
